import React, { Component } from 'react';
import { useState, useEffect } from 'react';
import { basePort, getUsernameJwt, headers, isExpiredJwt, renderRedirect, setTokenHeader, getJwtFromCookies, getRoleJwt } from "../../module_auth/AuthService"
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useNavigate } from "react-router-dom";
import { ToastMessage } from "../../component/common/Toast"

export function NoticeModiAdmin() {
    const queryParameters = new URLSearchParams(window.location.search)
    const id = queryParameters.get("id")

    //공지사항상세
    const [noticeTitle, setNoticeTitle] = useState("");
    const [noticeContent, setNoticeContent] = useState("");
    //End 공지사항상세

    const [mbrId, setMbrId] = useState("");

    const [jwtToken, setJwtToken] = useState("");
    const [redirect, setRedirect] = useState(false);
    const [accessToken, setAccessToken] = useState("");

    //toast
    const [showToast, setShowToast] = useState(false);
    const [msgToast, setMsgToast] = useState("");


    useEffect(() => {
        if(getJwtFromCookies() == null 
            || isExpiredJwt(getJwtFromCookies())
            || getRoleJwt(getJwtFromCookies()) != "ROLE_ADMIN"){
            setRedirect(true)
        } else {
            setAccessToken(getJwtFromCookies())
            setMbrId(getUsernameJwt(getJwtFromCookies()))
            loadEntity()
        }
    }, []);

    function loadEntity(){
        let url = basePort + '/get/notice/' + id
        fetch(url, 
          {method:'GET', headers,
            body:JSON.stringify()})
            .then(response => response.json())
            .then(response => {
                setNoticeTitle(response.noticeTitle)
                setNoticeContent(response.noticeContent)
          }).catch(error => console.log(error))
    }


    function clickSubmit(event) {
        event.preventDefault();
        setTokenHeader(getJwtFromCookies())
        fetch(basePort + '/update/notice', 
            {method:'post', headers,
                      body:JSON.stringify({
                        id:id,
                        mbrId: mbrId,
                        noticeTitle:noticeTitle,
                        noticeContent:noticeContent,
                    })})
                    .then(response => response.json())
                    .then(response => {
                    if(response.validRequest){
                        fadeOutToast(response.validationMessage)
                        setTimeout(function() {
                            moveTo()
                        }.bind(this), 3000)
                    } else {
                        fadeOutToast(response.validationMessage)
                    }
        }).catch(function(error) {
            console.log(error);
        });
    }

    function fadeOutToast(msg){
        setToastMessage(true, msg)
        setTimeout(function() {
            setToastMessage(false, "")
        }.bind(this), 3000);
    }

    function setToastMessage(show, message){
        setShowToast(show)
        setMsgToast(message)
    }

    let navigate = useNavigate();
    function moveTo() {
        let url = "/notice_list_admin"
        navigate(url);
    }

    function handleNoticeTitle(event) {
        setNoticeTitle(event.target.value);
    }

    function handleImage(){
        //nothing
    }

    return (
        <div>
            {renderRedirect(redirect, '/login')}
            <main class="page lanidng-page">
                <section>
                    <div class="container" style={{paddingTop:'100px', marginTop: '10px', marginBottom: '10px'}}>
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><span>공지사항</span></li>
                        <li class="breadcrumb-item"><span>공지사항수정</span></li>
                    </ol>
                    <form><label class="form-label" style={{textAlign: 'left', fontWeight: 'bold'}}>제목</label>
                        <input class="form-control" type="text" onChange={handleNoticeTitle} value={noticeTitle}/>
                    </form>
                    <form style={{marginTop: '10px', marginRight: '0', marginLeft: '0'}}>
                        <label class="form-label" style={{textAlign: 'left', fontWeight: 'bold'}}>내용</label>
                        <div class="container" style={{height:'350px', marginBottom:'10px'}}>
                        <ReactQuill theme="snow" value={noticeContent} onChange={setNoticeContent}
                            style={{height: '300px', marginBottom:'10px'}}
                            modules={{
                                toolbar: {
                                    container: [
                                        [{ header: '1' }, { header: '2' }, { header: [3, 4, 5, 6] }, { font: [] }],
                                        [{ size: [] }],
                                        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                        [{ list: 'ordered' }, { list: 'bullet' }],
                                        ['image'],
                                        ['clean'],
                                        ['code-block']
                                    ],
                                    handlers: {
                                        image: handleImage(),
                                    },
                                },
                                
                            }}
                        />
                    </div>
                    </form>
                    <form style={{textAlign: 'center', marginBottom: '10px', marginTop: '10px'}}>
                        <button class="btn btn-secondary" type="button" onClick={moveTo} style={{marginRight: '5px'}}>취소하기</button>
                        <button class="btn btn-primary" type="button" onClick={clickSubmit}>저장하기</button>
                    </form>
                    <ToastMessage show={showToast} msg={msgToast}/>
                    </div>
                </section>
            </main>
        </div>
    );
}